import {
  createStandardAction,
  ActionType,
  createReducer,
} from 'typesafe-actions';
// import produce from "immer";

/**
 * 타임라인 리덕스로 관리
 */

export type TSectionList = {
  startTime: number;
  endTime: number;
};

export type TTimelineState = {
  zoom: number;
  sectionIdx: number;
  sectionLists: TSectionList[];
};

export const initialState: TTimelineState = {
  zoom: 0,
  sectionIdx: 0,
  sectionLists: [
    {
      startTime: 0,
      endTime: 0,
    },
  ],
};

const SET_RANGE = 'timeline/SET_RANGE';
const ADD_SECTION = 'timeline/ADD_SECTION';
const PREV_SECTION = 'timeline/PREV_SECTION';
const NEXT_SECTION = 'timeline/NEXT_SECTION';
const SELECT_SECTION = 'timeline/SELECT_SECTION';

export const setTimelineAction = createStandardAction(SET_RANGE)<number>();
export const addSectionAction =
  createStandardAction(ADD_SECTION)<TSectionList[]>();
export const setPrevSectionAction =
  createStandardAction(PREV_SECTION)<number>();
export const setNextSectionAction =
  createStandardAction(NEXT_SECTION)<number>();
export const selectSectionAction =
  createStandardAction(SELECT_SECTION)<number>();

type actions = {
  setTimelineAction: typeof setTimelineAction;
  addSectionAction: typeof addSectionAction;
  setPrevSectionAction: typeof setPrevSectionAction;
  setNextSectionAction: typeof setNextSectionAction;
  selectSectionAction: typeof selectSectionAction;
};

type TimelineAction = ActionType<actions>;

const timeline = createReducer<TTimelineState, TimelineAction>(initialState, {
  [SET_RANGE]: (state, action) => ({
    ...state,
    ...action,
    zoom: action.payload,
  }),
  [ADD_SECTION]: (state, action) => ({
    ...state,
    ...action,
    sectionLists: action.payload,
  }),
  [PREV_SECTION]: (state, action) => ({
    ...state,
    ...action,
    sectionIdx: action.payload,
  }),
  [NEXT_SECTION]: (state, action) => ({
    ...state,
    ...action,
    sectionIdx: action.payload,
  }),
  [SELECT_SECTION]: (state, action) => ({
    ...state,
    ...action,
    sectionIdx: action.payload,
  }),
});

export default timeline;
